import React from 'react';
import { Button } from '@/lib/components/ui/button';
import { ArrowLeft } from 'lucide-react';

interface AbacHeaderProps {
  onSetPermissions: () => void;
  onSavePermissions: (name: string, description?: string) => void;
  onCancel: () => void;
  isEditing: boolean;
  viewMode: 'collection' | 'editor' | 'permissions';
}

export const AbacHeader: React.FC<AbacHeaderProps> = ({
  onSetPermissions,
  onSavePermissions,
  onCancel,
  isEditing,
  viewMode,
}) => {
  const getHeaderTitle = () => {
    if (viewMode === 'permissions') {
      return isEditing ? 'Update Permission' : 'Save Permission';
    }
    return isEditing ? 'Edit Permission' : 'Create Permission';
  };

  const getHeaderDescription = () => {
    if (viewMode === 'permissions') {
      return 'Review and confirm your permission settings';
    }
    return 'Configure attributes and access controls';
  };

  return (
    <header className="relative bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 px-8 py-6 shadow-xl">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-800/20 to-indigo-800/20"></div>

      <div className="relative flex items-center justify-between">
        <div className="flex items-center gap-6">
          <div>
            <h1 className="text-3xl font-bold text-white">{getHeaderTitle()}</h1>
            <p className="mt-1 text-blue-100/80">{getHeaderDescription()}</p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <Button
            variant="ghost"
            onClick={onCancel}
            className="group flex items-center gap-2 rounded-lg bg-white/10 px-4 py-2 text-white/90 backdrop-blur-sm transition-all duration-200 hover:bg-white/20 hover:text-white"
          >
            <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-0.5" />
            Back to Collections
          </Button>
        </div>
      </div>
    </header>
  );
};
